// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"cccd47b1","453":"6fef7265","458":"cc7ae432","741":"2a1f9b60","916":"7ad6aa25"}[chunkId] + ".chunk.js";
};